$(function() {
    AOS.init();

    window.addEventListener('load', AOS.refresh)
});

$(document).ready(function() {
    // OFI
    objectFitImages();

    /*
        GLOBAL
     */
    $(".fancybox").fancybox();

    $(window).on('scroll', function () {
        var actualScroll = $(window).scrollTop();

        if (actualScroll > 30) {
            $('header#header').addClass('scroll');
        } else {
            $('header#header').removeClass('scroll');
        }

        scroll = actualScroll;
    });

    var scroll = $(window).scrollTop();

    if (scroll > 30) {
        $('header#header').addClass('scroll');
    } else {
        $('header#header').removeClass('scroll');
    }

    if ($('.hero-block').length > 0) {
        $('.hero-block').css('height', $(window).height());

        $(window).on('resize', function () {
            $('.hero-block').css('height', $(window).height());
        });

        $(document).on('click', '.hero-block .scroll-to-next', function () {
            $('html, body').animate({scrollTop: $('.hero-block').innerHeight() - $('header#header').innerHeight()});
            return false;
        });
    }

    if ($('.hero-v2-block').length > 0) {
        $('.hero-v2-block').css('height', $(window).height());

        $(window).on('resize', function () {
            $('.hero-v2-block').css('height', $(window).height());
        });

        $(document).on('click', '.hero-v2-block .scroll-to-next', function () {
            $('html, body').animate({scrollTop: $('.hero-v2-block').innerHeight() - $('header#header').innerHeight()});
            return false;
        });

        $('.hero-v2-block .carousel').owlCarousel({
            items: 1,
            loop: true,
            nav: false,
            dots: false,
            autoplay: true,
            autoplayTimeout: 5000,
            animateOut: 'fadeOut',
            lazyLoad: true
        });
    }

    if (window.location.hash != '') {
        const dest = $(window.location.hash);

        if (dest.length > 0) {
            $('html, body').animate({scrollTop: $(dest).offset().top - $('header#header').innerHeight() - 20});
        }

        return false;
    }

    $(document).on('click', 'section a.btn', function (e) {
        const dest = $(this).attr('href');
        if (dest.indexOf('#') != -1) {
            const destId = dest.slice(dest.indexOf('#'));
            if ($(destId).length > 0) {
                $('html, body').animate({scrollTop: $(destId).offset().top - $('header#header').innerHeight()});

                e.preventDefault();
                e.stopPropagation();
                return false;
            }
        }
    });


    $(document).on('click', '#main-menu .navbar-nav .nav-item a:not(".wpml-ls-item-toggle")', function(e) {
       if ($(this).attr('href') == '#') {
           e.preventDefault();
           e.stopPropagation();
           return false;
       }
    });


    if ($('.testimonials-block').length > 0) {
        $('.testimonials-block .owl-carousel').owlCarousel({
            items: 1,
            loop: true,
            nav: false,
            navText: ["<svg id=\"Groupe_30\" data-name=\"Groupe 30\" xmlns=\"http://www.w3.org/2000/svg\" width=\"31\" height=\"31\" viewBox=\"0 0 31 31\">\n" +
            "  <path id=\"Vector_3\" data-name=\"Vector 3\" d=\"M0,4.149,4.392,0,8.785,4.149\" transform=\"translate(13.533 20.277) rotate(-90)\" fill=\"none\" stroke=\"#b51621\" stroke-width=\"2\"/>\n" +
            "  <g id=\"Ellipse_1\" data-name=\"Ellipse 1\" fill=\"none\" stroke=\"#b51621\" stroke-width=\"2\">\n" +
            "    <circle cx=\"15.5\" cy=\"15.5\" r=\"15.5\" stroke=\"none\"/>\n" +
            "    <circle cx=\"15.5\" cy=\"15.5\" r=\"14.5\" fill=\"none\"/>\n" +
            "  </g>\n" +
            "</svg>\n", "<svg xmlns=\"http://www.w3.org/2000/svg\" width=\"31\" height=\"31\" viewBox=\"0 0 31 31\">\n" +
            "  <g id=\"Groupe_29\" data-name=\"Groupe 29\" transform=\"translate(-1375 -4039)\">\n" +
            "    <path id=\"Vector_3\" data-name=\"Vector 3\" d=\"M0,0,4.392,4.149,8.785,0\" transform=\"translate(1388.318 4059.277) rotate(-90)\" fill=\"none\" stroke=\"#b51621\" stroke-width=\"2\"/>\n" +
            "    <g id=\"Ellipse_1\" data-name=\"Ellipse 1\" transform=\"translate(1375 4039)\" fill=\"none\" stroke=\"#b51621\" stroke-width=\"2\">\n" +
            "      <circle cx=\"15.5\" cy=\"15.5\" r=\"15.5\" stroke=\"none\"/>\n" +
            "      <circle cx=\"15.5\" cy=\"15.5\" r=\"14.5\" fill=\"none\"/>\n" +
            "    </g>\n" +
            "  </g>\n" +
            "</svg>\n"],
            dots: false,
            autoplay: true,
            autoplayTimeout: 3000,
            autoplayHoverPause: true,
            margin: 32,
            responsive: {
                991: {
                    autoWidth: true,
                }
            }
        });
    }

    if ($('.logos-list-block').length > 0) {
        $('.logos-list-block .owl-carousel').owlCarousel({
            items: 2,
            loop: true,
            nav: false,
            navText: ["<svg id=\"Groupe_30\" data-name=\"Groupe 30\" xmlns=\"http://www.w3.org/2000/svg\" width=\"31\" height=\"31\" viewBox=\"0 0 31 31\">\n" +
            "  <path id=\"Vector_3\" data-name=\"Vector 3\" d=\"M0,4.149,4.392,0,8.785,4.149\" transform=\"translate(13.533 20.277) rotate(-90)\" fill=\"none\" stroke=\"#b51621\" stroke-width=\"2\"/>\n" +
            "  <g id=\"Ellipse_1\" data-name=\"Ellipse 1\" fill=\"none\" stroke=\"#b51621\" stroke-width=\"2\">\n" +
            "    <circle cx=\"15.5\" cy=\"15.5\" r=\"15.5\" stroke=\"none\"/>\n" +
            "    <circle cx=\"15.5\" cy=\"15.5\" r=\"14.5\" fill=\"none\"/>\n" +
            "  </g>\n" +
            "</svg>\n", "<svg xmlns=\"http://www.w3.org/2000/svg\" width=\"31\" height=\"31\" viewBox=\"0 0 31 31\">\n" +
            "  <g id=\"Groupe_29\" data-name=\"Groupe 29\" transform=\"translate(-1375 -4039)\">\n" +
            "    <path id=\"Vector_3\" data-name=\"Vector 3\" d=\"M0,0,4.392,4.149,8.785,0\" transform=\"translate(1388.318 4059.277) rotate(-90)\" fill=\"none\" stroke=\"#b51621\" stroke-width=\"2\"/>\n" +
            "    <g id=\"Ellipse_1\" data-name=\"Ellipse 1\" transform=\"translate(1375 4039)\" fill=\"none\" stroke=\"#b51621\" stroke-width=\"2\">\n" +
            "      <circle cx=\"15.5\" cy=\"15.5\" r=\"15.5\" stroke=\"none\"/>\n" +
            "      <circle cx=\"15.5\" cy=\"15.5\" r=\"14.5\" fill=\"none\"/>\n" +
            "    </g>\n" +
            "  </g>\n" +
            "</svg>\n"],
            dots: false,
            autoplay: true,
            autoplayTimeout: 1000,
            autoplayHoverPause: true,
            margin: 32,
            lazyLoad: true,
            responsive: {
                768: {
                    items: 3
                },
                991: {
                    items: 4
                },
                1199: {
                    items: 6
                },
                1599: {
                    items: 7
                }
            }
        });
    }

    if ($('.logos-list-v2-block').length > 0) {
        $('.logos-list-v2-block .owl-carousel.toleft').owlCarousel({
            items: 3,
            loop:true,
            nav:false,
            dots:false,
            autoplay: true,
            slideTransition: 'linear',
            autoplayTimeout: 2500,
            autoplaySpeed: 2500,
            autoWidth:false,
            rewind: false,
            center: true,
            lazyLoad: true,
            responsive: {
                768: {
                    items: 4
                },
                991: {
                    items: 6
                },
                1199: {
                    items: 8
                },
                1599: {
                    items: 10
                }
            }
        });

        $('.logos-list-v2-block .owl-carousel.toright').owlCarousel({
            items: 2,
            loop:true,
            nav:false,
            dots:false,
            rtl: true,
            autoplay: true,
            slideTransition: 'linear',
            autoplayTimeout: 2500,
            autoplaySpeed: 2500,
            autoWidth:false,
            rewind: false,
            center: true,
            lazyLoad: true,
            responsive: {
                768: {
                    items: 3
                },
                991: {
                    items: 5
                },
                1199: {
                    items: 8
                },
                1599: {
                    items: 10
                }
            }
        });
    }

    if ($('.two-columns-images-text-carousel-block').length > 0) {
        $('.two-columns-images-text-carousel-block .carousel').owlCarousel({
            items: 1,
            loop: true,
            nav: true,
            navText: ["<svg id=\"Groupe_30\" data-name=\"Groupe 30\" xmlns=\"http://www.w3.org/2000/svg\" width=\"31\" height=\"31\" viewBox=\"0 0 31 31\">\n" +
            "  <path id=\"Vector_3\" data-name=\"Vector 3\" d=\"M0,4.149,4.392,0,8.785,4.149\" transform=\"translate(13.533 20.277) rotate(-90)\" fill=\"none\" stroke=\"#b51621\" stroke-width=\"2\"/>\n" +
            "  <g id=\"Ellipse_1\" data-name=\"Ellipse 1\" fill=\"none\" stroke=\"#b51621\" stroke-width=\"2\">\n" +
            "    <circle cx=\"15.5\" cy=\"15.5\" r=\"15.5\" stroke=\"none\"/>\n" +
            "    <circle cx=\"15.5\" cy=\"15.5\" r=\"14.5\" fill=\"none\"/>\n" +
            "  </g>\n" +
            "</svg>\n", "<svg xmlns=\"http://www.w3.org/2000/svg\" width=\"31\" height=\"31\" viewBox=\"0 0 31 31\">\n" +
            "  <g id=\"Groupe_29\" data-name=\"Groupe 29\" transform=\"translate(-1375 -4039)\">\n" +
            "    <path id=\"Vector_3\" data-name=\"Vector 3\" d=\"M0,0,4.392,4.149,8.785,0\" transform=\"translate(1388.318 4059.277) rotate(-90)\" fill=\"none\" stroke=\"#b51621\" stroke-width=\"2\"/>\n" +
            "    <g id=\"Ellipse_1\" data-name=\"Ellipse 1\" transform=\"translate(1375 4039)\" fill=\"none\" stroke=\"#b51621\" stroke-width=\"2\">\n" +
            "      <circle cx=\"15.5\" cy=\"15.5\" r=\"15.5\" stroke=\"none\"/>\n" +
            "      <circle cx=\"15.5\" cy=\"15.5\" r=\"14.5\" fill=\"none\"/>\n" +
            "    </g>\n" +
            "  </g>\n" +
            "</svg>\n"],
            dots: false,
            autoplay: false,
            lazyLoad: true
        });
    }


    if ($('.timeline-block').length > 0) {
        $(document).on('click', '.timeline-block .frise .date', function () {
            const date_index = $(this).data('date-index');

            $(this).closest('.timeline-block').find('.items .item.active').removeClass('active');
            $(this).closest('.timeline-block').find('.items .item[data-date-index="' + date_index + '"]').addClass('active');
            $(this).closest('.timeline-block').find('.frise .date.active').removeClass('active');
            $(this).addClass('active');

            return false;
        });

        /*
        $('.timeline-block').on('mousewheel', function (e) {
            const count_items = $(this).closest('.timeline-block').find('.items .item').length;
            const actual_index = $(this).closest('.timeline-block').find('.items .item.active').index();

            if (e.originalEvent.deltaY < 0) { // to right
                if (actual_index < (count_items - 1)) {
                    $(this).closest('.timeline-block').find('.items .item.active').removeClass('active');
                    $(this).closest('.timeline-block').find('.frise .date.active').removeClass('active');
                    $(this).closest('.timeline-block').find('.items .item').eq(actual_index + 1).addClass('active');
                    $(this).closest('.timeline-block').find('.frise .date').eq(actual_index + 1).addClass('active');
                    e.preventDefault();
                }
            } else { // to left
                if (actual_index > 0) {
                    $(this).closest('.timeline-block').find('.items .item.active').removeClass('active');
                    $(this).closest('.timeline-block').find('.frise .date.active').removeClass('active');
                    $(this).closest('.timeline-block').find('.items .item').eq(actual_index - 1).addClass('active');
                    $(this).closest('.timeline-block').find('.frise .date').eq(actual_index - 1).addClass('active');
                    e.preventDefault();
                }
            }
        });
        */
    }

    if ($('.timeline-vertical-v2-block').length > 0) {
        $('.timeline-vertical-v2-block .frise a.nav-link').on('click', function(e) {
            e.preventDefault();

            $(this).closest('.timeline-vertical-v2-block').find('.items .item.active').removeClass('active');

            const actual_scroll = $(this).closest('.timeline-vertical-v2-block').find('.items').scrollTop();
            const dest_element = $(this).attr('href');
            const element_position = $(dest_element).position().top;
            $(this).closest('.timeline-vertical-v2-block').find('.items').animate({
                scrollTop: parseInt(actual_scroll + element_position - 0)
            }, 500);

            $(dest_element).addClass('active');
        })


        $('.timeline-vertical-v2-block .items').on('activate.bs.scrollspy', function (e) {
            const date_index = $(this).closest('.timeline-vertical-v2-block').find('.frise .date.active').data('date-index');
            $(this).closest('.timeline-vertical-v2-block').find('.items .item.active').removeClass('active');
            $(this).closest('.timeline-vertical-v2-block').find('.items .item[data-date-index="' + date_index + '"]').addClass('active');
        })
    }


    if ($('.carousel-picto-title-text-v2-block').length > 0) {
        var owlCarouselPictoTitleText = $('.carousel-picto-title-text-v2-block .owl-carousel');
        owlCarouselPictoTitleText.owlCarousel({
            items: 1.15,
            loop: false,
            nav: false,
            dots: true,
            margin: 32,
            stagePadding: 100,
            responsive: {
                768: {
                    items: 1,
                    stagePadding: 100,
                },
                991: {
                    items: 2,
                    stagePadding: 100,
                },
                1199: {
                    items: 2,
                    stagePadding: 100,
                }
            }
        });

        /*
        owlCarouselPictoTitleText.on('mousewheel', '.owl-stage', function (e) {
            if (e.originalEvent.deltaY>0) {
                owlCarouselPictoTitleText.trigger('next.owl.carousel');
            } else {
                owlCarouselPictoTitleText.trigger('prev.owl.carousel');
            }
            e.preventDefault();
        });
        */
    }


    if ($('.form-map-block .acf-map').length > 0) {
        $('.form-map-block .acf-map').each(function () {
            var map = initMap($(this));
        });
    }

    if ($('body').hasClass('page-id-3662')) {
        let url = document.location.href;
        const url_split = url.split('?');

        if (url_split.length > 1) {
            url = url.split('?')[0];

            window.history.pushState({}, document.title, url);
        }
    }


/*
    if ($('.red-banner-block').length > 0) {

        // Support small text - copy to fill screen width
        if ($('.red-banner-block').find('.scrolling-text').outerWidth() < $(window).width()) {
            var windowToScrolltextRatio = Math.round($(window).width() / $('.red-banner-block').find('.scrolling-text').outerWidth()),
                scrollTextContent = $('.red-banner-block').find('.scrolling-text .scrolling-text-content').text(),
                newScrollText = '';
            for (var i = 0; i < windowToScrolltextRatio; i++) {
                newScrollText += ' \xa0 ' + scrollTextContent + ' \xa0 ';
            }
            $('.red-banner-block').find('.scrolling-text .scrolling-text-content').text(newScrollText);
        }

        // Init variables and config
        var scrollingText = $('.red-banner-block').find('.scrolling-text'),
            scrollingTextWidth = scrollingText.outerWidth(),
            scrollingTextHeight = scrollingText.outerHeight(true),
            startLetterIndent = parseInt(scrollingText.find('.scrolling-text-content').css('font-size'), 10) / 4.8,
            startLetterIndent = Math.round(startLetterIndent),
            scrollAmountBoundary = Math.abs($(window).width() - scrollingTextWidth),
            transformAmount = 0,
            leftBound = 0,
            rightBound = scrollAmountBoundary,
            transformDirection = $('.red-banner-block').hasClass('left-to-right') ? -1 : 1,
            transformSpeed = 200;

        // Read transform speed
        if ($('.red-banner-block').attr('speed')) {
            transformSpeed = $('.red-banner-block').attr('speed');
        }

        // Make scrolling text copy for scrolling infinity
        $('.red-banner-block').append(scrollingText.clone().addClass('scrolling-text-copy'));
        $('.red-banner-block').find('.scrolling-text').css({'position': 'absolute', 'left': 0});
        $('.red-banner-block').css('height', scrollingTextHeight);

        var getActiveScrollingText = function (direction) {
            var firstScrollingText = $('.red-banner-block').find('.scrolling-text:nth-child(1)');
            var secondScrollingText = $('.red-banner-block').find('.scrolling-text:nth-child(2)');

            var firstScrollingTextLeft = parseInt($('.red-banner-block').find('.scrolling-text:nth-child(1)').css("left"), 10);
            var secondScrollingTextLeft = parseInt($('.red-banner-block').find('.scrolling-text:nth-child(2)').css("left"), 10);

            if (direction === 'left') {
                return firstScrollingTextLeft < secondScrollingTextLeft ? secondScrollingText : firstScrollingText;
            } else if (direction === 'right') {
                return firstScrollingTextLeft > secondScrollingTextLeft ? secondScrollingText : firstScrollingText;
            }
        }

        $(window).on('wheel', function (e) {
            var delta = e.originalEvent.deltaY;

            if (delta > 0) {
                // going down
                transformAmount += transformSpeed * transformDirection;
                $('.red-banner-block').find('.scrolling-text .scrolling-text-content').css('transform', 'skewX(10deg)');
            } else {
                transformAmount -= transformSpeed * transformDirection;
                $('.red-banner-block').find('.scrolling-text .scrolling-text-content').css('transform', 'skewX(-10deg)');
            }
            setTimeout(function () {
                $('.red-banner-block').find('.scrolling-text').css('transform', 'translate3d(' + transformAmount * -1 + 'px, 0, 0)');
            }, 10);
            setTimeout(function () {
                $('.red-banner-block').find('.scrolling-text .scrolling-text-content').css('transform', 'skewX(0)');
            }, 500)

            // Boundaries
            if (transformAmount < leftBound) {
                var activeText = getActiveScrollingText('left');
                activeText.css({'left': Math.round(leftBound - scrollingTextWidth - startLetterIndent) + 'px'});
                leftBound = parseInt(activeText.css("left"), 10);
                rightBound = leftBound + scrollingTextWidth + scrollAmountBoundary + startLetterIndent;

            } else if (transformAmount > rightBound) {
                var activeText = getActiveScrollingText('right');
                activeText.css({'left': Math.round(rightBound + scrollingTextWidth - scrollAmountBoundary + startLetterIndent) + 'px'});
                rightBound += scrollingTextWidth + startLetterIndent;
                leftBound = rightBound - scrollingTextWidth - scrollAmountBoundary - startLetterIndent;
            }
        });
    }*/
});


/**
 * initMap
 *
 * Renders a Google Map onto the selected jQuery element
 *
 * @date    22/10/19
 * @since   5.8.6
 *
 * @param   jQuery $el The jQuery element.
 * @return  object The map instance.
 */
function initMap( $el ) {

    // Find marker elements within map.
    var $markers = $el.find('.marker');

    // Create gerenic map.
    var mapArgs = {
        zoom        : $el.data('zoom') || 16,
        mapTypeId   : google.maps.MapTypeId.ROADMAP
    };
    var map = new google.maps.Map( $el[0], mapArgs );

    // Add markers.
    map.markers = [];
    $markers.each(function(){
        initMarker( $(this), map );
    });

    // Center map based on markers.
    centerMap( map );

    // Return map instance.
    return map;
}

/**
 * initMarker
 *
 * Creates a marker for the given jQuery element and map.
 *
 * @date    22/10/19
 * @since   5.8.6
 *
 * @param   jQuery $el The jQuery element.
 * @param   object The map instance.
 * @return  object The marker instance.
 */
function initMarker( $marker, map ) {

    // Get position from marker.
    var lat = $marker.data('lat');
    var lng = $marker.data('lng');
    var latLng = {
        lat: parseFloat( lat ),
        lng: parseFloat( lng )
    };

    // Create marker instance.
    var marker = new google.maps.Marker({
        position : latLng,
        map: map
    });

    // Append to reference for later use.
    map.markers.push( marker );

    // If marker contains HTML, add it to an infoWindow.
    if( $marker.html() ){

        // Create info window.
        var infowindow = new google.maps.InfoWindow({
            content: $marker.html()
        });

        // Show info window when marker is clicked.
        google.maps.event.addListener(marker, 'click', function() {
            infowindow.open( map, marker );
        });
    }
}

/**
 * centerMap
 *
 * Centers the map showing all markers in view.
 *
 * @date    22/10/19
 * @since   5.8.6
 *
 * @param   object The map instance.
 * @return  void
 */
function centerMap( map ) {

    // Create map boundaries from all map markers.
    var bounds = new google.maps.LatLngBounds();
    map.markers.forEach(function( marker ){
        bounds.extend({
            lat: marker.position.lat(),
            lng: marker.position.lng()
        });
    });

    // Case: Single marker.
    if( map.markers.length == 1 ){
        map.setCenter( bounds.getCenter() );

        // Case: Multiple markers.
    } else{
        map.fitBounds( bounds );
    }
}